<template>
  <InfoChip :text="text" text-bold>
    <template #prepend>
      <div class="dot" />
    </template>
  </InfoChip>
</template>

<script setup lang="ts">
import InfoChip from '@/hospitalAdminTool/components/common/InfoChip.vue'

interface Props {
  text: string
}

defineProps<Props>()
</script>

<style scoped>
.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #17b26a;
}
</style>
